<template>
  <div class="container goods-change">
    <header><h3>商品{{breadText}}</h3></header>
    <Form ref="form" :model="postData" class="form" :label-width="140">
      <FormItem :label="breadText + '单号'">
        {{postData.orderSn}}
      </FormItem>
      <FormItem :label="breadText + '日期'" prop="date">
        <DatePicker style="width: 240px" v-model="date" @on-change="dateChange" :clearable="false"
                    :editable="false" :options="datePickerOptions"></DatePicker>
      </FormItem>
      <FormItem :label="breadText + '仓库'" v-if="$route.query.type !== 'transfer'" prop="inventoryCode"
                :rules="{ required: true, message: '请选择仓库' }">
        <!--<InventorySelect style="width: 240px" v-model="postData.inventoryCode" disabled/>-->
        {{inventoryName}}
      </FormItem>
      <template v-else>
        <FormItem label="调出仓库" prop="fromInventoryCode" :rules="{ required: true, message: '请选择仓库' }">
          <!--<InventorySelect style="width: 240px" v-model="postData.fromInventoryCode" disabled/>-->
          {{inventoryName}}
        </FormItem>
        <FormItem label="调入仓库" prop="toInventoryCode" :rules="{ required: true, message: '请选择仓库' }">
          <InventorySelect style="width: 240px" v-model="postData.toInventoryCode" :all="1"></InventorySelect>
        </FormItem>
      </template>
      <FormItem>
        <Card style="width: 60vw; min-width: 800px" dis-hover>
          <p slot="title">商品列表</p>
          <Button @click="handlePicker" type="text" icon="plus-circled" slot="extra">添加商品</Button>
          <Table :data="tableData" :columns="columns"></Table>
          <Table :data="tableDataTotal" :columns="totalColumns" :show-header="false"></Table>
        </Card>
      </FormItem>
      <FormItem>
        <div class="form-bottom-buttons">
          <Button type="success"
                  v-if="$route.query.id"
                  @click="handleUpdate">保存
          </Button>
          <Button type="success"
                  v-else
                  :disabled="disabledSubmit"
                  @click="handleAdd">{{breadText}}
          </Button>
          <Button 
                  @click="$router.back()">取消
          </Button>
        </div>
      </FormItem>
    </Form>
    <GoodsPicker v-model="showPickerModal" :ids="ids" :inventory-code="inventoryCode"
                 :disabled-same="type !== 'storage'" @on-change="onPickerChange"></GoodsPicker>
  </div>
</template>

<script>
  import GoodsPicker from './goodsPicker';
  import InventorySelect from './inventorySelect';
  import { formatDate } from 'utils';

  const title = {
    storage: '入库',
    transfer: '调拨',
    damaged: '报损'
  };

  export default {
    name: 'goodsChange',
    components: {
      GoodsPicker,
      InventorySelect
    },
    data() {
      return {
        datePickerOptions: {
          disabledDate(date) {
            return date - Date.now() > 0;
          }
        },
        disabledSubmit: false,
        ids: [],
        type: '',
        date: new Date(),
        postData: {
          date: formatDate(new Date(), 'yyyy-MM-dd'),
          inventoryCode: this.$store.state.goods.inventoryCode,
          toInventoryCode: '',
          fromInventoryCode: this.$store.state.goods.inventoryCode,
          orderSn: '',
          comList: []
        },
        tableData: [],
        columns: [],
        initColumns: [
          {
            title: '操作',
            render: (h, param) => {
              const index = param.index;
              const style = {
                cursor: 'pointer'
              };
              return <div>
                <span onClick={() => this.handleDelete(index)}><icon title="删除" style={style}
                                                                     type="ios-trash" color="#d8321f"
                                                                     size="20"/></span>
              </div>;
            }
          },
          {
            title: '商品名称',
            key: 'commodity_name'
          },
          {
            title: '商品类别',
            key: 'cate_name'
          },
          {
            title: '商品单位',
            key: 'unit'
          },
          {
            title: '库存量',
            key: 'stock_balance'
          },
          {
            title: '单位成本',
            key: 'cost',
            render: (h, param) => {
              const item = param.row;
              return <i-input on-on-focus={() => this.disabledSubmit = true} on-on-blur={e => {
                this.disabledSubmit = false;
                let value = +e.target.value;
                if (Number.isNaN(value)) value = 0;
                item.cost = value;
                item.total_cost = this.calTotalCost(item.amount, item);
                this.$set(this.tableData, param.index, item);
              }} value={+item.cost}/>;
            }
          },
          {
            title: `入库量`,
            key: 'amount',
            render: (h, param) => {
              const item = param.row;
              return <i-input min={0} value={item.amount} on-on-focus={() => this.disabledSubmit = true}
                              on-on-blur={e => {
                                this.disabledSubmit = false;
                                let value = +e.target.value;
                                if (value > +item.stock_balance && this.type !== 'storage') {
                                  value = +item.stock_balance;
                                  this.$Message.error('数量不能大于库存');
                                }
                                if (!Number.isInteger(value)) {
                                  this.$Message.error('请输入整数');
                                  value = Math.round(value);
                                }
                                item.amount = value;
                                item.total_cost = this.calTotalCost(item.amount, item);
                                this.$set(this.tableData, param.index, item);
                              }}/>;
            }
          },
          {
            title: '总成本',
            key: 'total_cost',
            render: (h, param) => {
              const item = param.row;
              return <div>{item.total_cost}</div>;
            }
          },],
        showPickerModal: false,
      };
    },
    computed: {
      inventoryCode() {
        if (this.type === 'transfer') {
          return this.postData.fromInventoryCode;
        } else {
          return this.postData.inventoryCode;
        }
      },
      inventoryName() {
        return this.$store.getters['goods/inventoryName'];
      },
      breadText() {
        return this.$route.meta.breadText;
      },
      totalColumns() {
        const [first, name, type, unit, storage, cost, amount, totalAmount] = this.initColumns;
        let change = [{ key: 'cost' }, { key: 'amount' }];
        if (this.$route.query.type !== 'storage') {
          change = [{ key: 'amount' }];
        }
        return [{ key: 'title' }, name, type, unit, storage, ...change, totalAmount];
      },
      tableDataTotal() {
        const amount = this.tableData.reduce((total, item) => total + Number(item.amount), 0);
        const total_cost = this.tableData.reduce((total, item) => total + Number(item.total_cost), 0).toFixed(2);
        return [{
          title: '总计',
          amount,
          total_cost
        }];
      },
      title() {
        return title[this.$route.query.type];
      }
    },
    beforeRouteEnter(to, from, next) {
      to.meta.breadText = title[to.query.type];
      next();
    },
    created() {
      const [first, name, amountType, unit, storage, amount, transfer, totalAmount] = this.initColumns;
      const type = this.$route.query.type;
      this.type = type;
      if (type === 'storage') {
        this.columns = this.initColumns;
      } else if (type === 'damaged') {
        this.columns = [first, name, amountType, unit, storage, { ...transfer, title: '报损量' }, totalAmount];
      } else if (type === 'transfer') {
        this.columns = [first, name, amountType, unit, storage, { ...transfer, title: '调拨量' }, totalAmount];
      }
      this.tableData = this.$route.params.items.map(item => {
        return { ...item, amount: 0, total_cost: 0, cost: 0 };
      });
      this.getOrderSn();
    },
    methods: {
      dateChange(e) {
        this.postData.date = e;
      },
      calTotalCost(value, item) {
        let num = value;
        let total = 0;
        if (this.type === 'storage') {
          total = num * item.cost;
        } else {
          const { inoutList } = item;
          for (let item of inoutList) {
            num -= item.num;
            if (num <= 0) {
              total += (item.num + num) * item.cost;
              break;
            } else {
              total += item.num * item.cost;
            }
          }
        }
        return total.toFixed(2);
      },
      onPickerChange(data) {
        this.tableData = [...this.tableData, ...[{ ...data[0], cost: 0 }]];
      },
      getOrderSn() {
        const url = '/web/inventory/orderSn';
        const type = this.type === 'storage' ? 1 : this.type === 'transfer' ? 2 : 3;
        this.$service.post(url, { type }).then(res => {
          if (res.data.errorcode === 0) {
            const data = res.data.data;
            this.postData.orderSn = data.orderSn;
          } else {
            this.$Message.error(res.data.errormsg);
          }
        }).catch(e => {
          throw new Error(e);
        });
      },
      handleDelete(index) {
        this.tableData.splice(index, 1);
      },
      handlePicker() {
        this.ids = this.tableData.map(item => item.id);
        this.showPickerModal = true;
      },
      handlePrice(val) {
        this.postData.commodity_price = +this.postData.commodity_price.toFixed(2);
      },
      checkTableData() {
        for (let item of this.tableData) {
          if (+item.amount === 0) {
            this.$Message.error('数量不能为0');
            return false
          }
        }
        return true
      },
      async handleAdd() {
        const { fromInventoryCode, toInventoryCode } = this.postData;
        if (toInventoryCode && toInventoryCode === fromInventoryCode) return this.$Message.error('调入调出仓库不能相同');

        let valid = this.checkTableData();
        if (!valid) return false;
        valid = await this.$refs.form.validate();
        if (!valid) return this.$Message.error('表单错误');
        this.postData.comList = this.tableData;
        let url = '';
        if (this.type === 'storage') {
          url = '/web/inventory/in';
        } else if (this.type === 'damaged') {
          url = '/web/inventory/checkOut';
        } else {
          url = '/web/inventory/allotOut';
        }
        this.$service.post(url, this.postData).then(res => {
          if (res.data.errorcode === 0) {
            this.$Message.success(res.data.errormsg);
            this.$router.push({ path: '/commodity/list', query: { tab: 1 } });
          } else {
            this.$Message.error(res.data.errormsg);
          }
        }).catch(e => {
          throw new Error(e);
        });
      },
    }
  };
</script>

<style lang="less" scoped>
  .ivu-card-body {
    padding: 0
  }

  .goods-image {
    height: 100px;
    width: 100px;
    margin-bottom: 10px;
    border: 2px solid #ccc;

    img {
      max-height: 100%;
      min-height: 100%;
    }
  }
</style>
